export default "__VITE_ASSET__DewfQiK$__"